module.exports = __webpack_public_path__ + "media/images/icons/country_flags/vg-4c507ebc698924eb248c9621378c6a30.svg";